import React, { useCallback, useMemo } from "react";
import { Typography, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useStyles } from "src/pages/ServiceOrdersDetails/components/styles";
import { useSODetailsContext } from "src/providers/SODetailsStore";
import MonteraCard from "src/components/MonteraCard";
import EditIcon from "src/pages/ServiceOrdersDetails/components/icons/EditIcon";
import DescriptionIcon from "src/pages/ServiceOrdersDetails/components/icons/DescriptionIcon";
import { useAppContext } from "src/providers/AppProvider";
import { isIncompleteOrNewOrMissingInformation } from "src/utils/functions";

const Description = () => {
  const classes = useStyles();
  const { t } = useTranslation("orders");
  const {
    state: { user },
  } = useAppContext();
  const {
    serviceOrderDetails: { serviceOrder },
  } = useSODetailsContext();
  const {
    callAppAPI: { toggleModal },
  } = useAppContext();

  const handleDescriptionEdit = useCallback(() => {
    toggleModal({ id: "editDescriptionSO", status: true });
  }, []);

  const disabledByStatus = useMemo(() => {
    return isIncompleteOrNewOrMissingInformation(serviceOrder?.statusMatchingName);
  }, [serviceOrder.statusMatchingName]);

  const isIntegrated = useMemo(() => !user?.partner?.isIntegration, [user?.partner?.isIntegration]);

  return (
    <MonteraCard
      headerIcon={<DescriptionIcon />}
      title={t("labels.summary_cards.description")}
      action={
        isIntegrated && disabledByStatus ? (
          <IconButton onClick={handleDescriptionEdit}>
            <EditIcon style={{ width: 16, height: 16 }} />
          </IconButton>
        ) : (
          <></>
        )
      }
    >
      <div className={classes.contentWrap}>
        <Typography variant="caption" className={classes.caption}>
          {t("labels.summary_cards.description")}
        </Typography>
        <Typography variant="body1" className={classes.description}>
          {serviceOrder.description || `No description`}
        </Typography>
      </div>
    </MonteraCard>
  );
};

export default Description;
